// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "main" + "." + "979aa19138fae53f05b0" + ".css";
};